module.exports = __webpack_public_path__ + "static/media/praying-hands.a9b261f9.svg";